import {
  put, takeLatest, all,
} from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import einvoiceEwaybillActions, { einvoiceEwaybillActionTypes } from '../../actions/integrations/einvoiceEwaybillActions';
import einvoiceEwaybillServices from '../../services/integrations/einvoiceEwaybillServices';
import React from 'react';
import FormHelpers from '../../helpers/FormHelpers';

function* _enableEinvoiceEwayBill(action) {
  try {
    yield put(einvoiceEwaybillActions.enableEinvoiceEwaybillLoading(true));
    const address = yield einvoiceEwaybillServices.enableEinvoiceEwaybill(action?.payload);
    if (address.success) {
      yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.ENABLE_EWAY_BILL.SUCCESS, {
        request: action?.payload,
        response: address,
      }));
      notification.open({
        type: 'success',
        message: 'Ewaybill Registration Successfully initiated',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(address.address);
      }
    } else {
      notification.open({
        type: 'error',
        message: address.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(einvoiceEwaybillActions.enableEinvoiceEwaybillLoading(false));
  } catch (error) {
    yield put(einvoiceEwaybillActions.enableEinvoiceEwaybillLoading(false));
    yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.ENABLE_EWAY_BILL.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* enableEinvoiceEwayBill() {
  yield takeLatest(einvoiceEwaybillActionTypes.ENABLE_EWAY_BILL.REQUEST, _enableEinvoiceEwayBill);
}

function* _genEwayBill(action) {
  try {
    yield put(einvoiceEwaybillActions.genEwaybillLoading(true));
    const address = yield einvoiceEwaybillServices.genEwaybill(action?.payload);
    const formattedHTML = FormHelpers.formatErrorMessage(address.message);
    if (address.success) {
      yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.GEN_EWAY_BILL.SUCCESS, {
        request: action?.payload,
        response: address,
      }));
      notification.open({
        type: 'success',
        message: 'Ewaybill Registration Successfully initiated',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(address.address);
      }
    } else {
      notification.open({
        type: 'error',
        message: 'Couldn\'t generate Ewaybill',
        description: (
          <div dangerouslySetInnerHTML={{ __html: formattedHTML }} />
        ),
        duration: 4,
        placement: 'top',
      });
    }
    yield put(einvoiceEwaybillActions.genEwaybillLoading(false));
  } catch (error) {
    yield put(einvoiceEwaybillActions.genEwaybillLoading(false));
    yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.GEN_EWAY_BILL.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* genEwayBill() {
  yield takeLatest(einvoiceEwaybillActionTypes.GEN_EWAY_BILL.REQUEST, _genEwayBill);
}

function* _getEwayBills(action) {
  try {
    yield put(einvoiceEwaybillActions.getEwaybillsLoading(true));
    const {
      page, limit, keyword, tenantId, doctype, status, fromDate, toDate,
    } = action;
    const eWaybills = yield einvoiceEwaybillServices.getEwaybills(page, limit, keyword, tenantId, doctype, status, fromDate, toDate);
    yield put(einvoiceEwaybillActions.getEwaybillsSuccess(eWaybills));
    if (action.callback) {
      action.callback(eWaybills);
    }
    yield put(einvoiceEwaybillActions.getEwaybillsLoading(false));
  } catch (error) {
    yield put(einvoiceEwaybillActions.getEwaybillsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.GET_EWAY_BILLS.ERROR, error));
  }
}

/**
 *
 */
function* getEwayBills() {
  yield takeLatest(einvoiceEwaybillActionTypes.GET_EWAY_BILLS.REQUEST, _getEwayBills);
}

function* _GSTAuthentication(action) {
  try {
    yield put(einvoiceEwaybillActions.GSTAuthenticationLoading(true));
    const address = yield einvoiceEwaybillServices.GSTAuthentication(action?.payload);
    if (address.success) {
      yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.AUTH_GST_SUVIDHA.SUCCESS, {
        request: action?.payload,
        response: address,
      }));
      notification.open({
        type: 'success',
        message: 'Your account is not connected to e-Way Bill Portal',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(address.address);
      }
    } else {
      notification.open({
        type: 'error',
        message: address.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(einvoiceEwaybillActions.GSTAuthenticationLoading(false));
  } catch (error) {
    yield put(einvoiceEwaybillActions.GSTAuthenticationLoading(false));
    yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.AUTH_GST_SUVIDHA.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* GSTAuthentication() {
  yield takeLatest(einvoiceEwaybillActionTypes.AUTH_GST_SUVIDHA.REQUEST, _GSTAuthentication);
}

function* _GSTDeauthentication(action) {
  try {
    yield put(einvoiceEwaybillActions.GSTDeauthenticationLoading(true));
    const address = yield einvoiceEwaybillServices.GSTDeauthentication(action?.payload);
    if (address.success) {
      yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.DEACTIVATE_GST_SUVIDHA.SUCCESS, {
        request: action?.payload,
        response: address,
      }));
      notification.open({
        type: 'success',
        message: 'e-Way Bill portal disconnected successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(address.address);
      }
    } else {
      notification.open({
        type: 'error',
        message: address.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(einvoiceEwaybillActions.GSTDeauthenticationLoading(false));
  } catch (error) {
    yield put(einvoiceEwaybillActions.GSTDeauthenticationLoading(false));
    yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.DEACTIVATE_GST_SUVIDHA.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* GSTDeauthentication() {
  yield takeLatest(einvoiceEwaybillActionTypes.DEACTIVATE_GST_SUVIDHA.REQUEST, _GSTDeauthentication);
}

function* _PushIRP(action) {
  try {
    yield put(einvoiceEwaybillActions.pushIRPLoading(true));
    const pushIRPResponse = yield einvoiceEwaybillServices.pushIRP(action?.payload);

    if (pushIRPResponse.success) {
      notification.open({
        type: 'success',
        message: 'IRP Pushed Successfully',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: pushIRPResponse.message,
        duration: 4,
        placement: 'top',
      });
    }

    if (action.callback) {
      action.callback(pushIRPResponse.address);
    }

    yield put(einvoiceEwaybillActions.pushIRPLoading(false));
  } catch (error) {
    yield put(einvoiceEwaybillActions.pushIRPLoading(false));
    yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.PUSH_IRP.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* PushIRP() {
  yield takeLatest(einvoiceEwaybillActionTypes.PUSH_IRP.REQUEST, _PushIRP);
}
function* _PushCnToIRP(action) {
  try {
    yield put(einvoiceEwaybillActions.pushCnToIRPLoading(true));
    const pushCnToIRPResponse = yield einvoiceEwaybillServices.pushCnToIRP(action?.payload);

    if (pushCnToIRPResponse.success) {
      notification.open({
        type: 'success',
        message: 'IRP Pushed Successfully',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: pushCnToIRPResponse.message,
        duration: 4,
        placement: 'top',
      });
    }

    if (action.callback) {
      action.callback(pushCnToIRPResponse.address);
    }

    yield put(einvoiceEwaybillActions.pushCnToIRPLoading(false));
  } catch (error) {
    yield put(einvoiceEwaybillActions.pushCnToIRPLoading(false));
    yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.PUSH_CN_TO_IRP.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* PushCnToIRP() {
  yield takeLatest(einvoiceEwaybillActionTypes.PUSH_CN_TO_IRP.REQUEST, _PushCnToIRP);
}

function* _cancelIRP(action) {
  try {
    yield put(einvoiceEwaybillActions.cancelIRPLoading(true));
    const cancelIRPResponse = yield einvoiceEwaybillServices.cancelIRP(action?.payload);
    if (cancelIRPResponse.success) {
      notification.open({
        type: 'success',
        message: 'IRP Cancelled Successfully',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: cancelIRPResponse.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (action.callback) {
      action.callback(cancelIRPResponse.address);
    }
    yield put(einvoiceEwaybillActions.cancelIRPLoading(false));
  } catch (error) {
    yield put(einvoiceEwaybillActions.cancelIRPLoading(false));
    yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.CANCEL_IRP.ERROR, {
      request: action,
      error,
    }));
  }
}

function* cancelIRP() {
  yield takeLatest(einvoiceEwaybillActionTypes.CANCEL_IRP.REQUEST, _cancelIRP);
}

function* _cancelEwaybill(action) {
  try {
    yield put(einvoiceEwaybillActions.cancelEwaybillLoading(true));
    const cancelEwaybillResponse = yield einvoiceEwaybillServices.cancelEwaybill(action?.payload);
    if (cancelEwaybillResponse.success) {
      notification.open({
        type: 'success',
        message: 'Ewaybill Cancelled Successfully',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: cancelEwaybillResponse.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (action.callback) {
      action.callback(cancelEwaybillResponse.address);
    }
    yield put(einvoiceEwaybillActions.cancelEwaybillLoading(false));
  } catch (error) {
    yield put(einvoiceEwaybillActions.cancelEwaybillLoading(false));
    yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.CANCEL_EWAY_BILL.ERROR, {
      request: action,
      error,
    }));
  }
}

function* cancelEwaybill() {
  yield takeLatest(einvoiceEwaybillActionTypes.CANCEL_EWAY_BILL.REQUEST, _cancelEwaybill);
}
function* _addTransporter(action) {
  try {
    yield put(einvoiceEwaybillActions.addTransporterLoading(true));
    const addTransporterResponse = yield einvoiceEwaybillServices.addTransporter(action?.payload);
    if (addTransporterResponse.success) {
      notification.open({
        type: 'success',
        message: 'Transporter updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(addTransporterResponse.address);
      }
    } else {
      notification.open({
        type: 'error',
        message: addTransporterResponse.message,
        description: addTransporterResponse.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(einvoiceEwaybillActions.addTransporterLoading(false));
  } catch (error) {
    yield put(einvoiceEwaybillActions.addTransporterLoading(false));
    yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.ADD_TRANSPORTATION.ERROR, {
      request: action,
      error,
    }));
  }
}

function* addTransporter() {
  yield takeLatest(einvoiceEwaybillActionTypes.ADD_TRANSPORTATION.REQUEST, _addTransporter);
}

function* _excludeEwayBills(action) {
  try {
    yield put(einvoiceEwaybillActions.excludeEwayBillsLoading(true));
    const excludedEwayBills = yield einvoiceEwaybillServices.excludeEwayBills(action?.payload);
    if (excludedEwayBills.success) {
      notification.open({
        type: 'success',
        message: 'e-Way Bills have been excluded successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: excludedEwayBills.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(einvoiceEwaybillActions.excludeEwayBillsLoading(false));
  } catch (error) {
    yield put(einvoiceEwaybillActions.excludeEwayBillsLoading(false));
    yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.EXCLUDE_EWAY_BILLS.ERROR, {
      request: action,
      error,
    }));
  }
}

function* excludeEwayBills() {
  yield takeLatest(einvoiceEwaybillActionTypes.EXCLUDE_EWAY_BILLS.REQUEST, _excludeEwayBills);
}

function* _fetchEwayBill(action) {
  try {
    yield put(einvoiceEwaybillActions.fetchEwayBillLoading(true));
    const ewayBill = yield einvoiceEwaybillServices.fetchEwayBill(action?.payload);
    if (ewayBill.success) {
      notification.open({
        type: 'success',
        message: 'e-Way Bills has been updated successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: ewayBill.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(einvoiceEwaybillActions.fetchEwayBillLoading(false));
  } catch (error) {
    yield put(einvoiceEwaybillActions.fetchEwayBillLoading(false));
    yield put(TrackerActions.trackAction(einvoiceEwaybillActionTypes.FETCH_EWAY_BILL.ERROR, {
      request: action,
      error,
    }));
  }
}

function* fetchEwayBill() {
  yield takeLatest(einvoiceEwaybillActionTypes.FETCH_EWAY_BILL.REQUEST, _fetchEwayBill);
}

export default function* einvoiceEwaybillSaga() {
  yield all([
    enableEinvoiceEwayBill(),
    GSTAuthentication(),
    GSTDeauthentication(),
    PushIRP(),
    PushCnToIRP(),
    genEwayBill(),
    getEwayBills(),
    cancelIRP(),
    cancelEwaybill(),
    addTransporter(),
    excludeEwayBills(),
    fetchEwayBill(),
  ]);
}
